import axios from 'axios';
import React, { useRef } from 'react'
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';

const CreateTeamModal = (props) => {
    const globalState = useSelector((state) => state);
    const name = useRef(null)
    const note = useRef(null)
    const CreateTeamFn = () => {
        Swal.showLoading();
        // // console.log("save")
        // setModalOpen(true);
        // // console.log(name)
        // // console.log(note?.current?.value)
        const vname = name?.current?.value;
        axios.post(`${BASE_URL}/capstone/teamformation/createteam.php`, {
            name: vname,
            note: note?.current?.value,
        })
            .then(res => {
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    props.assignTeam(res_data_data)
                    // console.log("res_data_data")
                    // console.log(res_data_data)
                    // console.log(res_data_data)
                    // props.setInGroup(true);
                    // props.setTeamName(vname);
                    // props.setTeamMembers([globalState?.permissions?.fullname]);
                }
                Swal.fire('Saved!', '', 'success')
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "We couldn't create your team. Please try again.", "", "warning")
                // Swal.fire('Changes are not saved', '', 'info');
            })
    }
    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.toggle}
            centered={true}
            returnFocusAfterClose={false}
            unmountOnClose={false}
            backdrop={"static"}
        // size={"sm"}
        // fullscreen={"true"}
        >
            <ModalHeader toggle={props.toggle}>Create New Team</ModalHeader>
            <ModalBody>
                <h4 className='mb-1' >Please enter team name : </h4>
                <input ref={name} type="text" className='form-control'
                    style={{

                        border: "1px solid rgb(249 99 50) ",
                        // borderRadius: "10px",

                    }}
                />
                <h4 className='mb-1' >Feel free to add some notes : </h4>
                <textarea ref={note} name="" id="" className='form-control' cols="30" rows="10"
                    style={{

                        border: "1px solid rgb(249 99 50) ",
                        borderRadius: "10px",

                    }}
                />
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-primary" onClick={CreateTeamFn}>
                    Save
                </button>{' '}
                <button className="btn btn-secondary" onClick={props.toggle}>
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateTeamModal
